export default __webpack_public_path__ + "static/media/1281.9fb070e9.png";